import { EnumFlyingQuoteType } from '@domains/research/shared';
import { EnumLanguage } from '@libs/constants';


/**------------------------------------------------------
 * Enum Definitions
 */
export { EnumFlyingQuoteType } from '@domains/research/shared';


/**------------------------------------------------------
 * Data Structure
 */
export interface IFlyingQuoteSuggestions {
	search			: string;
	type			: EnumFlyingQuoteType;
	language		: EnumLanguage;
	suggestions		: string[];
}
